export const HEADER_HEIGHT = '72px';
export const TABLET_HEADER_HEIGHT = '54px';
